module.exports = __webpack_public_path__ + "static/media/profile_pic2_400x400.5a2fd817.png";